import { useFloating, autoUpdate, offset, flip, shift, arrow } from '@floating-ui/react-dom';
import { useRef, useEffect } from 'react';
import { TOOLTIP_OFFSET_PX, WINDOW_MARGIN_PX } from '../tooltip/constants.js';

function usePosition(props) {
  const arrowRef = useRef(null);
  const floating = useFloating({
    strategy: "fixed",
    placement: props.placement,
    open: props.active,
    whileElementsMounted: autoUpdate,
    middleware: props.middlewares ?? [offset((props.offsetPx ?? TOOLTIP_OFFSET_PX) + (props.withArrow ? 8 : 0)), flip({
      padding: props.marginPx ?? WINDOW_MARGIN_PX
    }), shift({
      padding: props.marginPx ?? WINDOW_MARGIN_PX,
      crossAxis: true
    }), arrow({
      element: arrowRef
    })]
  });
  useEffect(() => {
    if (typeof props.containerRef === "function") {
      throw new Error("<Overlay />: incompatible RefCallback given for props.containerRef (you must use a RefObject!)");
    }
    floating.refs.setReference(props.containerRef?.current ?? null);
  }, [props.containerRef, floating.refs]);
  return {
    floating,
    arrowRef
  };
}

export { usePosition };
//# sourceMappingURL=hook.position.js.map
